<template>
    <v-list>
      <v-card v-for="brief in data" class="mb-5">
        <v-list-item>
          <v-list-item-avatar size="100" tile>
            <v-img :src="productImage('https://res.cloudinary.com/twodm/image/fetch/' + brief.data.product_link.url)"></v-img>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title class="title" >{{ brief.data.campaign_title[0].text }}</v-list-item-title>
            <v-list-item-subtitle class="text--primary"><v-icon class="mr-1" color="primary">mdi-map-marker</v-icon>{{ brief.data.country }}</v-list-item-subtitle>
<!--            <v-list-item-subtitle><prismic-rich-text :field="brief.data.brief"/></v-list-item-subtitle>-->
          </v-list-item-content>
          <v-list-item-action>
            <v-list-item-action-text class="title text--primary">$ {{ brief.data.budget }}</v-list-item-action-text>
            <v-row align="center">
              <v-icon left color="yellow">mdi-sack-percent</v-icon>
              <span class="title mr-2">{{ brief.data.commission }}%</span>
            </v-row>
          </v-list-item-action>
        </v-list-item>
      </v-card>
    </v-list>
</template>

<script>
export default {
  name: 'briefCard',
  props: {
    data: Array,
  },
  methods: {
    productImage(url) {
      return `https://ws-na.amazon-adsystem.com/widgets/q?_encoding=UTF8&MarketPlace=US&ASIN=${url.split('/').pop()}&ServiceVersion=20070822&ID=AsinImage&WS=1&Format=SL250`;
    },
  },
};
</script>

<style scoped>

</style>
